import { Moment } from 'moment';

export const INFO_MONTH_FORMAT = 'MM.YYYY';
export const INFO_DATE_FORMAT = 'DD.MM.YYYY';
export const FILE_EXPORT_DATE_FORMAT = 'DDMMYYYY';
export const INFO_DATE_FORMAT_WITH_TIME = 'DD.MM.YYYY HH:mm';
export const FORM_INPUT_DISPLAY_DATE_FORMAT = 'DD.MM.YYYY';
export const FORM_INPUT_DISPLAY_DATE_FORMAT_WITH_TIME = 'DD.MM.YYYY HH:mm';
export const FORM_INPUT_DATA_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const isFromDateEarlierThanToDate = (
  fromDate: Moment | undefined,
  toDate: Moment | undefined
) => {
  if (!fromDate || !toDate) {
    return true;
  }
  return fromDate < toDate;
};
